function initScrollFillText() {
  const el = document.querySelector(".ts-quote__right-quote");
  if (!el) return;

  const text = el.dataset.text;
  el.innerHTML = "";

  [...text].forEach((char) => {
    const span = document.createElement("span");
    span.textContent = char;
    el.appendChild(span);
  });

  const spans = el.querySelectorAll("span");
  const total = spans.length;

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;

    const isMobile = window.innerWidth < 900;

    const activationStart = isMobile ? 0.05 * docHeight : 0.01 * docHeight;

    const activationEnd = isMobile ? docHeight - 0.05 * docHeight : docHeight - 0.1 * docHeight;

    if (scrollTop < activationStart) return;

    const relativeProgress = Math.min((scrollTop - activationStart) / (activationEnd - activationStart), 1);
    const multiplier = isMobile ? 20 : 7;

    const lettersToFill = Math.floor(relativeProgress * total * multiplier);

    spans.forEach((span, index) => {
      span.style.color = index < lettersToFill ? "#121212" : "rgba(18, 18, 18, 0.12)";
    });
  });
}

window.addEventListener("DOMContentLoaded", initScrollFillText);
